module.exports = __webpack_public_path__ + "fonts/ralewaymediumitalic.ef38a0f.ttf";